import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>Made by -Abhay Singh Verma&copy; 2023; All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
